module.exports = __webpack_public_path__ + "static/media/101932297_696433607838504_912223067663499264_n.a92c5c8d.jpg";